import Controller from "./editableMultipleFields.controller";
import template from "./editableMultipleFields.html";

const editableMultipleFields = {
  template,
  controller: Controller,
  bindings: {
    fieldTitle: "@",
    fields: "=",
    keys: "<",
    isDisabled: "=?",
    eventName: "<",
    responseDoneEventName: "<",
    extraParams: "<",
  },
};

export default editableMultipleFields;



// WEBPACK FOOTER //
// ./src/components/editableMultipleFields/editableMultipleFields.component.js